import { LexicalNode, NodeMap } from 'lexical/LexicalNode'

import { $isGroupMentionNode } from '../nodes/GroupMentionNode'
import { $isMentionNode } from '../nodes/MentionNode'

export interface MentionsType {
  label: string
  value: number | string
}

export function getMentionsValues(nodesMap?: NodeMap): number[] {
  const valueSet = new Set<number>()
  if (nodesMap) {
    nodesMap.forEach((node: LexicalNode) => {
      if ($isMentionNode(node)) {
        const value = Number(node.__mentionValue)
        if (!isNaN(value)) {
          if (!valueSet.has(value)) {
            valueSet.add(value)
          }
        }
      }
    })
  }
  return Array.from(valueSet)
}

export function getGroupMentionsValues(nodesMap?: NodeMap): number[] {
  const valueSet = new Set<number>()
  if (nodesMap) {
    nodesMap.forEach((node: LexicalNode) => {
      if ($isGroupMentionNode(node)) {
        const value = Number(node.__groupMentionValue)
        if (!isNaN(value)) {
          if (!valueSet.has(value)) {
            valueSet.add(value)
          }
        }
      }
    })
  }
  return Array.from(valueSet)
}
